/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtClaimPositionFee = {
  pool: Address;
  position: Address;
  owner: Address;
  feeAClaimed: bigint;
  feeBClaimed: bigint;
};

export type EvtClaimPositionFeeArgs = {
  pool: Address;
  position: Address;
  owner: Address;
  feeAClaimed: number | bigint;
  feeBClaimed: number | bigint;
};

export function getEvtClaimPositionFeeEncoder(): FixedSizeEncoder<EvtClaimPositionFeeArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["position", getAddressEncoder()],
    ["owner", getAddressEncoder()],
    ["feeAClaimed", getU64Encoder()],
    ["feeBClaimed", getU64Encoder()],
  ]);
}

export function getEvtClaimPositionFeeDecoder(): FixedSizeDecoder<EvtClaimPositionFee> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["position", getAddressDecoder()],
    ["owner", getAddressDecoder()],
    ["feeAClaimed", getU64Decoder()],
    ["feeBClaimed", getU64Decoder()],
  ]);
}

export function getEvtClaimPositionFeeCodec(): FixedSizeCodec<
  EvtClaimPositionFeeArgs,
  EvtClaimPositionFee
> {
  return combineCodec(
    getEvtClaimPositionFeeEncoder(),
    getEvtClaimPositionFeeDecoder(),
  );
}
